import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.resize()
  }

  resize() {
    this.measure()
    requestAnimationFrame(() => this.measure())
  }

  measure() {
    const element = this.element

    // Hide overflow during resize to prevent scrollbar flicker
    const previousOverflow = element.style.overflowY
    element.style.overflowY = 'hidden'

    // Reset height to get the correct scrollHeight
    element.style.height = 'auto'

    const newHeight = Math.max(element.scrollHeight, 20)
    const limitedHeight = Math.min(newHeight, 142)
    element.style.height = limitedHeight + 'px'

    const lineHeight = parseFloat(getComputedStyle(element).lineHeight) || 20
    element.classList.toggle('is-multiline', limitedHeight > lineHeight + 1)

    // Add scrollbar if content exceeds 142px
    if (element.scrollHeight > 142) {
      element.style.overflowY = 'auto'
    } else {
      element.style.overflowY = previousOverflow || 'hidden'
    }
  }
}